// React
import React from "react";
// Bootstrap
import { Well, Button } from "react-bootstrap";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./ErrorMessageBlock.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export class ErrorMessageBlock extends React.Component {
    render() {
        let { title, subTitle, buttonText, buttonCallback, button2Text, button2Callback } = this.props;
        return (React.createElement("div", { className: styles.container },
            React.createElement(Well, { className: styles.errorMessages },
                React.createElement("h3", null, title),
                React.createElement("h4", null, subTitle),
                React.createElement(Button, { bsStyle: "primary", onClick: () => buttonCallback() }, buttonText),
                button2Callback && React.createElement(Button, { bsStyle: "default", onClick: () => button2Callback() }, button2Text),
                React.createElement("p", null,
                    "If you'd like to let us know, pop us an email: ",
                    React.createElement("a", { href: `mailto:${callCentreEmail}` }, callCentreEmail)))));
    }
}
